module.exports = __webpack_public_path__ + "media/A41.d56ff791.mp3";